module.exports = __webpack_public_path__ + "img/btnok.bf44e6dd.png";